import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SearchBar from '../components/search/Search.component';
import { useSearch } from '../core/search';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

const SearchView = ({ search, tag, list }) => {
  const dispatch = useDispatch();

  const {
    conf: { placeholder },
    actions: { search: searchChange },
  } = search;
  const { handleChangeSearch } = useSearch(searchChange);
  const { value } = useSelector((state) => state[tag].search);
  const {
    list: { selected, pagination: { pageSize } },
  } = useSelector((state) => state[tag]);

  const [valueSearch, setValueSearch] = useState(value || '');

  const handleDebouncedSearch = useMemo(
    () =>
      _.debounce((searchTerm) => {
        handleChangeSearch(searchTerm);
        dispatch(list?.actions?.pagination({ page: 1, pageSize: pageSize }));
      }, 300),

    [handleChangeSearch, dispatch, list?.actions, pageSize]
  );

  const onChange = useCallback(
    (event) => {
      const text = event.target.value;
      setValueSearch(text);
      handleDebouncedSearch(text);
      if (!_.isEmpty(selected)) dispatch(list.actions.resetSelect());
    },
    // eslint-disable-next-line
    [handleDebouncedSearch, selected, list, dispatch]
  );

  useEffect(() => {
    setValueSearch(value);
  }, [value]);

  return (
    <SearchBar
      placeholder={placeholder}
      onChange={onChange}
      value={valueSearch}
    />
  );
};

export default SearchView;
